/** Component to wait for the editor to be mounted, send a notification */

import { useEditorMounted } from '@platejs/core/react'
import { useEffect } from 'react'

export const EditorMounted = ({ onMounted }: { onMounted(): void }) => {
  /** This hook must run inside of a Plate component */
  const isMounted = useEditorMounted()
  useEffect(() => {
    if (!isMounted) {
      return
    }
    onMounted()
  }, [isMounted, onMounted])
  // No rendering for this one
  return null
}
